import React from 'react';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import CheckIcon from '../Icons/CheckIcon';

const DeactiveInstructions: React.FC = () => {
  const { t } = useTranslation(['modalBeneficiariesDeactivation']);

  const instructionsMap = [
    { id: 1, text: t('verify') },
    { id: 2, text: `${t('fill')}`, isStrong: [t('attention')] },
    { id: 3, text: `${t('case_cpf')}` },
    { id: 5, text: `${t('save_in_format')} .csv`, isStrong: ['.csv'] },
  ];

  return (
    <>
      <span className="instruction-title">
        {isMobile ? t('instructions_to_send_mobile') : t('instructions_to_send')}
      </span>
      <div className="instructions-wrapper">
        {instructionsMap.map(({ id, text, isStrong }) => (
          <div key={id} className="instruction-box">
            <CheckIcon />
            <p>
              {text
                .split(' ')
                .map((word) => (isStrong && isStrong.includes(word) ? <strong key={word}>{word}</strong> : `${word} `))}
            </p>
          </div>
        ))}
      </div>
    </>
  );
};

export default DeactiveInstructions;
